export const REGEX = {
  EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,7}$/,
  PHONE: /^\+?\d{8,15}$/
};
